export const SpacerPdf = (props: { height?: number }) => {
    return (
        <div style={{ height: props.height ? `${props.height}rem` : '1.7rem' }} />
    );
};

SpacerPdf.parseProps = (atts: any) => {
    return {
        height: atts.height,
    };
};
